import { Button } from "@mantine/core";
import { type JSX, useEffect, useState } from "react";
import type { GuideActionOption } from "../logic-builder";

interface GuideActionButtonProps {
    className: string;
    currentStep: string;
    isLoadingStep: boolean;
    onClick: (option: GuideActionOption) => void;
    option: GuideActionOption;
}

export function GuideActionButton({
    className,
    currentStep,
    isLoadingStep,
    onClick,
    option,
}: GuideActionButtonProps): JSX.Element {
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const handleButtonClick = () => {
        setIsLoadingButton(true);
        onClick(option);
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: fix later
    useEffect(() => {
        setIsLoadingButton(false);
    }, [currentStep]);

    return (
        <Button
            className={className}
            loading={isLoadingStep && isLoadingButton}
            disabled={isLoadingStep}
            miw="5.5rem"
            onClick={handleButtonClick}
            size="xs"
            fz="xs"
            variant={option.variant ?? "default"}
        >
            {option.label}
        </Button>
    );
}
